import React, { useEffect, useReducer, useState } from 'react'
import { Link, Navigate, useLoaderData, useNavigate } from 'react-router-dom'
import { Button } from '@/Components/ui/button'
import UploadBox from '@/Components/UploadBox'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/Components/ui/select'
import HeaderCard from '@/Components/HeaderCard'
import BodyCard from '@/Components/BodyCard'
import TextLabel from '@/Components/Common/TextLabel'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/Components/ui/table'
import assets from '@/assets/assets'
import { format } from 'date-fns'
import Constant from '@/utils/Constant'
import Loader from '@/Components/Common/Loader'
import CreateBulkPagination from './CreateBulkPagination'
import Axios from '@/Axios'
import BulkUploadService from '@/Service/BulkUploadService'
import { generateRandomeString } from '@/utils/helper'
import { Input } from '@/Components/ui/input'
import StatusBadge from '@/Components/Common/StatusBadge'
import * as XLSX from 'xlsx'

const UpdateBulkUpload = () => {
    const { bulkUpload } = useLoaderData()
    const navigate = useNavigate()
    console.log("loader data : ", bulkUpload)
    const [event, updateEvent] = useReducer(
        (prev, next) => {
            return { ...prev, ...next }
        },
        {
            bulkUpload: null,
            file: null,
            isReadyForImport: false,
            isImporting: false,
            currentPage: 1,
            currentErrorTablePage: 1,
            isDataPreparing: false,
            uploadedData: [],
            uniqueUploadedData: [],
            paginatedData: [],
            errorData: [],
            errorMessages: [],
            paginatedErrorMessages: [],
        }
    )

    useEffect(() => {
        if(!bulkUpload){
            navigate("/bulk-upload")
        }
        updateEvent({ bulkUpload })
        fetchAndValidatedFile(bulkUpload.import_file)
    }, [bulkUpload])

    const fetchAndValidatedFile = async (fileUrl) => {
        try{
            const options = { 
                file_url : fileUrl,
            }
            let axiosResponse = await BulkUploadService.getFileData(options);
            let data = await axiosResponse.arrayBuffer()
            console.log("data : ", data)
            const workbook = XLSX.read(data);
        
            let worksheets = workbook.SheetNames.map(sheetName => {
                return { sheetName, data: XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]) };
            });
        
            console.log("json:\n", JSON.stringify(worksheets), "\n\n");
        
        }catch(e){console.log("error : ",e)}
    }

    

    return (
        <>
            <HeaderCard>
                <div className="flex items-center justify-end gap-2">
                    {event?.bulkUpload?.import_file && (
                        <Link to={import.meta.env.VITE_BACKEND_URL_ORIGIN + event?.bulkUpload?.import_file} download={true}>
                            <Button
                                className="bg-primary-purpal hover:bg-primary-purpal px-4"
                                iconType="Download"
                            >
                                Download File {event.isImporting && <Loader fullScreen={false} />}
                            </Button>
                        </Link>
                    )}
                </div>
            </HeaderCard>
            <BodyCard>
                <div>
                    <div className="grid grid-cols-4 gap-2">
                        <div>
                            <TextLabel text="Document Type" />
                            <div className="mt-1 text-[13px] border border-gray-200 rounded-md py-1 px-2 text-gray-500 shadow-sm">
                                {event.bulkUpload?.document_type}
                            </div>
                        </div>
                        <div>
                            <TextLabel text="Status" />
                            <div className="mt-1 text-[13px] border border-gray-200 rounded-md py-1 px-2 text-gray-500 shadow-sm">
                                {/* <StatusBadge status={} /> */}
                                {event.bulkUpload?.status}
                            </div>
                        </div>
                        <div>
                            <TextLabel text="Uploaded Count" />
                            <div className="mt-1 text-[13px] border border-gray-200 rounded-md py-1 px-2 text-gray-500 shadow-sm">
                                {event.bulkUpload?.uploaded_count}
                            </div>
                        </div>
                        <div>
                            <TextLabel text="Failed Count" />
                            <div className="mt-1 text-[13px] border border-gray-200 rounded-md py-1 px-2 text-gray-500 shadow-sm">
                                {event.bulkUpload?.failed_count}
                            </div>
                        </div>
                    </div>
                    <hr className="my-4" />
                </div>
                {event.paginatedData.length > 0 && (
                    <div className="mt-3 ">
                        <TextLabel text={`Preview`} />
                        <small className="text-red-500">Make sure to hit the 'Import' button or the data won’t be saved.</small>
                        <div className="overflow-auto overflow-card-scroll">
                            <Table className="mt-2" style={{ width: '150%' }}>
                                <TableHeader>
                                    <TableRow className="border">
                                        <TableHead key="BULK_UPLOAD_HEAD_0" className="border text-left text-[13px] font-bold">
                                            Sr.No
                                        </TableHead>
                                        {assets.data.workAllocationHeaders.map((value, i) => (
                                            <TableHead key={'BULK_UPLOAD_HEAD_' + (i + 1)} className="border text-left text-[13px] font-bold">
                                                {value.value}
                                            </TableHead>
                                        ))}
                                    </TableRow>
                                </TableHeader>
                                <TableBody>
                                    {event.paginatedData.map((row, currentIndex) => (
                                        <TableRow
                                            key={
                                                'BULK_UPLOAD_DATA_' +
                                                (currentIndex + 1 + (Constant.PAGINATION_SIZE * event.currentPage - Constant.PAGINATION_SIZE))
                                            }
                                            className="border"
                                        >
                                            <TableCell className="border text-[13px] text-left py-2">
                                                {currentIndex + 1 + (Constant.PAGINATION_SIZE * event.currentPage - Constant.PAGINATION_SIZE)}
                                            </TableCell>
                                            <TableCell className="border text-[13px] text-left py-2">{row['client']}</TableCell>
                                            <TableCell className="border text-[13px] text-left py-2">{row['mr_number']}</TableCell>
                                            <TableCell className="border text-[13px] text-left py-2">{row['patient_name']}</TableCell>
                                            <TableCell className="border text-[13px] text-left py-2">{row['arrived_date']}</TableCell>
                                            <TableCell className="border text-[13px] text-left py-2">{row['payor_type_hchb']}</TableCell>
                                            <TableCell className="border text-[13px] text-left py-2">{row['assessment_type']}</TableCell>
                                            <TableCell className="border text-[13px] text-left py-2">{row['status']}</TableCell>
                                            <TableCell className="border text-[13px] text-left py-2">{row['priority']}</TableCell>
                                            <TableCell className="border text-[13px] text-left py-2">{row['coder']}</TableCell>
                                            <TableCell className="border text-[13px] text-left py-2">{row['production_tl']}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </div>
                        <CreateBulkPagination
                            totalCount={event.uploadedData.length}
                            onPageChange={(currentPage) => {
                                const startIndex = (currentPage - 1) * Constant.PAGINATION_SIZE
                                const endIndex = startIndex + Constant.PAGINATION_SIZE
                                const paginatedData = event.uploadedData.slice(startIndex, endIndex)
                                updateEvent({ paginatedData: paginatedData, currentPage })
                            }}
                        />
                    </div>
                )}

                {event.paginatedErrorMessages.length > 0 && (
                    <div className="mt-3 ">
                        <TextLabel text={`Import File Errors and Warnings`} />
                        <div className="overflow-auto overflow-card-scroll">
                            <Table className="mt-2">
                                <TableHeader>
                                    <TableRow className="border">
                                        <TableHead key="BULK_UPLOAD_ERROR_0" className="border text-left text-[13px] font-bold w-20">
                                            Sr.No
                                        </TableHead>
                                        {assets.data.workAllocationImportErrors.map((value, i) => (
                                            <TableHead key={'BULK_UPLOAD_ERROR_' + (i + 1)} className="border text-left text-[13px] font-bold">
                                                {value.value}
                                            </TableHead>
                                        ))}
                                    </TableRow>
                                </TableHeader>
                                <TableBody>
                                    {event.paginatedErrorMessages.map((row, currentIndex) => (
                                        <TableRow
                                            key={
                                                'BULK_UPLOAD_ERROR_' +
                                                (currentIndex +
                                                    1 +
                                                    (Constant.PAGINATION_SIZE * event.currentErrorTablePage - Constant.PAGINATION_SIZE))
                                            }
                                            className="border"
                                        >
                                            <TableCell className="border text-[13px] text-left py-2">
                                                {currentIndex +
                                                    1 +
                                                    (Constant.PAGINATION_SIZE * event.currentErrorTablePage - Constant.PAGINATION_SIZE)}
                                            </TableCell>
                                            <TableCell className="border text-[13px] text-left py-2" dangerouslySetInnerHTML={{ __html: row }} />
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </div>
                        <CreateBulkPagination
                            totalCount={event.errorMessages.length}
                            onPageChange={(currentPage) => {
                                const startIndex = (currentPage - 1) * Constant.PAGINATION_SIZE
                                const endIndex = startIndex + Constant.PAGINATION_SIZE
                                const paginatedData = event.errorMessages.slice(startIndex, endIndex)
                                updateEvent({ paginatedErrorMessages: paginatedData, currentErrorTablePage: currentPage })
                            }}
                        />
                    </div>
                )}

                {event.isDataPreparing && (
                    <div className="mt-3 flex gap-3 ">
                        <TextLabel text={`Validating Data...`} /> <Loader fullScreen={false} />
                    </div>
                )}
            </BodyCard>
        </>
    )
}

export default UpdateBulkUpload
